import { withStyles } from '@material-ui/core/styles';
import theme from 'theme';
import { CognitoLogin, CognitoForgotPassword } from 'AuthProvider/AmplifyAuthProvider';

const pageStyles = () => ({
  button: { ...theme.button },
});

const Login = withStyles(pageStyles)(({ classes, ...props }) => {
  const { button } = classes;
  return (
    <CognitoLogin
      loginFormStyle={{ button }}
      passwordFormStyle={{ button }}
      {...props}
    />
  );
});

const ForgotPassword = withStyles(pageStyles)(({ classes, ...props }) => {
  const { button } = classes;
  return (
    <CognitoForgotPassword
      changePasswordFormStyle={{ button }}
      resetPasswordFormStyle={{ button }}
      {...props}
    />
  );
});

export { Login, ForgotPassword };
